import React from 'react';
import { Grid, Table, Modal, Button,Tab} from 'semantic-ui-react';
import MeterTab from "./meter-tab"
import { withRouter } from "react-router-dom";
import * as qs from "query-string";

import * as api from '../../api';
import { NoData } from "../../components/table/no-data";
import UtilityMeterTableHeader from "./utilitymeter-table-header";
import UtilityMeterTableRow from "./utilitymeter-table-row";
import FilterableDatatable from "../../components/table/filterable-data-table";
import ApiDataProvider from "../../components/table/data-providers/api-data-provider";
import HalfHourMeterTab from "./meter-hh-tab"
import SupplierInvoices from "./meters-supplier-invoices-tab"
import ServiceManagementTab from '../service-management/service-management-tab';

class MeterTableRow extends React.Component {

    constructor(props) {

        super(props);
        this.setupPanes();
    }

    state = { 
        utility: 'Gas', 
        loadingread:true ,

        address : "",
        serialnumber : "",
        ref : "",
        propertyname : "",
        lastreading : "",
        lastreadtype : "",
        datelastread : "",
        description : "",
        isModalOpen: false,
        metersCount: {},
        completenessData: [],
        params: qs.parse(this.props.location.search)
       
    }


    getMeterRead  = (customerId, meterSiteKey) => {
    
    }

    openModal = (e) => {
        e.stopPropagation();
        this.setState({ isModalOpen: true });
      };
      
      closeModal = () => {
        this.setState({ isModalOpen: false });
      };

    setupPanes = () => {
        
        this.panes.push( { menuItem: 'Meter Details', render: () => <Tab.Pane> 
            <Grid.Column>
        <div className="table-container">
            <FilterableDatatable dataProvider={new ApiDataProvider(api.getUtilityMeters, [this.props.data.meterSiteKey])} name="utility meters" canExport={true}
                                contextData={{customerId: this.props.contextData.customerId}} defaultSort={"id"}
                                headerComponent={UtilityMeterTableHeader} rowComponent={UtilityMeterTableRow}/>
        </div>
    </Grid.Column> </Tab.Pane> })

    if(this.state.params.meterReadMode === undefined )
    {
              this.panes.push( { menuItem: 'Half Hour Data', render: () => <Tab.Pane><HalfHourMeterTab siteKey={this.props.data.siteKey} meterSiteKey={this.props.data.meterSiteKey} customerId={ this.props.contextData.customerId} /></Tab.Pane> })   
              this.panes.push( { menuItem: 'Supplier Invoices', render: () => <Tab.Pane><SupplierInvoices siteKey={this.props.data.siteKey} meterSiteKey={this.props.data.meterSiteKey} customerId={ this.props.contextData.customerId} /></Tab.Pane> })   
              this.panes.push( { menuItem: 'Cases', render: () => <Tab.Pane><ServiceManagementTab siteKey={this.props.data.siteKey} meterSiteKey={this.props.data.meterSiteKey} utility={this.props.data.utility} 
              caseLabel={this.props.data.serialNumber + " - " + this.props.data.utility } customerId={ this.props.contextData.customerId}></ServiceManagementTab></Tab.Pane> })   

            }
    }

    panes = [];


  
    render() {
        const { selected } = this.props;
        return (
            <Table.Row
            onClick={(e) => {
                e.preventDefault(); // Prevent default behavior
                e.stopPropagation(); // Stop event propagation
                if (!this.state.isModalOpen && this.props.onRowSelect) {
                  this.props.onRowSelect(this.props.data.siteKey, this.props.data.meterSiteKey);
                }
              }}
              negative={selected}
              >        
                <Table.Cell>{this.props.data.utility || <NoData />}</Table.Cell>
                <Table.Cell>{this.props.data.serialNumber || <NoData />}</Table.Cell>
                <Table.Cell>{this.props.data.reference || <NoData />}</Table.Cell>
                <Table.Cell>{this.props.data.meterType || <NoData />}</Table.Cell>
                <Table.Cell>{this.props.data.meterDescription || <NoData />}</Table.Cell>
                <Table.Cell>{this.props.data.msStatus || <NoData />}</Table.Cell>
                <Table.Cell>{this.props.data.supplyAddress || <NoData />}</Table.Cell>
                <Table.Cell>{
                
                this.props.data.connectionType === "IMP" ? "Import" : 
                (this.props.data.connectionType === "EXP" ? "Export" :
                (this.props.data.connectionType === "GEN" ? "Generation" : "")
                )
                
                || <NoData />}</Table.Cell>
                <Table.Cell>
                <Button basic onClick={this.openModal}>
    Meter Detail
  </Button>
  <Modal
    size="large"
    open={this.state.isModalOpen}
    onClose={this.closeModal}
    centered={true}
    closeIcon
  >
                        <Modal.Header><h2>{this.props.data.meterSiteKey}</h2></Modal.Header>
                        <Modal.Content>
                            <Grid padded stackable columns='equal' verticalAlign='middle'>
                                <Grid.Row>
                                    <Grid.Column>
                                        <MeterTab meter={this.props.data} customerId={this.props.contextData.customerId} />
                                    </Grid.Column>
                                </Grid.Row>

                                <Grid.Row>
                                    <Grid.Column>
                                        <Tab panes={this.panes} />
                                    </Grid.Column>
                                </Grid.Row> 
                            </Grid>
                        </Modal.Content>
                        
                    </Modal>

                </Table.Cell>
            </Table.Row>
        );
    }
}

export default withRouter(MeterTableRow);